import { useEffect, useRef } from 'react';

/**
 * IntersectionObserver sentinel for infinite scroll lists.
 */
export function useInfiniteScroll({
  enabled = true,
  hasNextPage = false,
  isFetchingNextPage = false,
  fetchNextPage,
  rootMargin = '200px',
}) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!enabled || !hasNextPage || isFetchingNextPage || !fetchNextPage) return undefined;

    const node = sentinelRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          fetchNextPage();
        }
      },
      { rootMargin },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [enabled, hasNextPage, isFetchingNextPage, fetchNextPage, rootMargin]);

  return sentinelRef;
}
